module.exports = __webpack_public_path__ + "static/media/dispute-empty.0d578a73.svg";